import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { pairingsFor, isLightHex } from "../../lib/foilPairings";

const K_MASK = "url(/branding/downloads/kolt-printing-icon-transparent-1024.png) center / contain no-repeat";
const tid = (s) => s.toLowerCase().replace(/\s+/g, "-");

// Paper tile with the foil swatch clipped into the K — the finished combination at a glance.
export const FoilOnPaper = ({ foil, paperHex, className = "" }) => (
  <div className={`relative overflow-hidden ${className}`} style={{ backgroundColor: paperHex }} aria-hidden>
    <div className="absolute inset-[18%]" style={{ WebkitMaskImage: K_MASK, maskImage: K_MASK, backgroundImage: `url(${foil.img})`, backgroundSize: "cover", backgroundPosition: "center" }} />
  </div>
);

export function FoilPairings({ foil, compact = false }) {
  const pairs = pairingsFor(foil);
  return (
    <div data-testid="foil-pairings">
      <div className="flex items-baseline justify-between gap-2 mb-2">
        <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/50">Pairs with Colorplan</div>
        {!compact && <Link to="/tools/colorplan" className="font-mono text-[9px] tracking-[0.18em] uppercase text-[#E8B587] hover:text-white inline-flex items-center gap-1" data-testid="foil-pairings-colorplan">All 55 <ArrowUpRight className="w-3 h-3" /></Link>}
      </div>
      <div className={`grid gap-1.5 ${compact ? "grid-cols-6" : "grid-cols-3"}`}>
        {pairs.map((p) => (
          <div key={p.name} className="group relative">
            <Link to={`/quote?product=${encodeURIComponent("Foil stamping")}&foil=${encodeURIComponent(foil.code)}&paper=${encodeURIComponent(`Colorplan ${p.name}`)}&tool=foil-color-chart`} className="block" title={`Quote foil ${foil.code} on Colorplan ${p.name} · contrast ${p.contrast.toFixed(1)}:1`} data-testid={`foil-pairing-${tid(p.name)}`}>
              <FoilOnPaper foil={foil} paperHex={p.hex} className={`aspect-square border ${isLightHex(p.hex) ? "border-slate-300" : "border-white/10"} group-hover:border-[#B87333] transition-colors`} />
              {!compact && (
                <div className="mt-1 leading-tight">
                  <div className="text-[11px] font-bold text-white/90 truncate">{p.name}</div>
                  <div className="font-mono text-[9px] tracking-wider uppercase text-white/45 truncate">{p.why}</div>
                </div>
              )}
            </Link>
          </div>
        ))}
      </div>
      {!compact && <div className="text-[10px] text-white/45 mt-2" data-testid="foil-pairings-hint">Tap a paper to quote this foil on that Colorplan shade.</div>}
    </div>
  );
}
